import React from 'react'

type PopoverProps<T> = readonly [T | null, boolean, (event: React.MouseEvent<T>) => void, () => void]

export function usePopover<T = HTMLElement>(): PopoverProps<T> {
  const [anchorEl, setAnchorEl] = React.useState<T | null>(null)

  const handleClick = React.useCallback((event: React.MouseEvent<T>) => {
    setAnchorEl(event.currentTarget)
  }, [])

  const handleClose = React.useCallback(() => {
    setAnchorEl(null)
  }, [])

  const open = Boolean(anchorEl)

  return [anchorEl, open, handleClick, handleClose] as const
}
